export const isValidField = (field, minLength = 3) => {
    const trimmed = field?.trim();
    return !!trimmed && trimmed?.length >= minLength;
};